import React from 'react';

const LinkText = ({
  text,
  className = 'text-indigo-600 underline font-medium',
}) => {
  if (!text) return <>—</>;

  const parts = text.split(/(@:[^\s]+)/g);

  return (
    <>
      {parts.map((part, index) => {
        if (!part.startsWith('@:')) {
          return <React.Fragment key={index}>{part}</React.Fragment>;
        }

        const rawLink = part.substring(2);

        const href = /^https?:\/\//i.test(rawLink)
          ? rawLink
          : `https://${rawLink}`;

        return (
          <a
            key={index}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className={className}
          >
            {rawLink}
          </a>
        );
      })}
    </>
  );
};

export default LinkText;